module.exports = __webpack_public_path__ + "static/whitlock_owner-1fb8cb1807609e665eafaafd20b2d5ad.jpg";